<ng-container *transloco="let t">
  @if (ready) {
    <form [formGroup]="group">
      @if (definition.groups && definition.groups.length) {
        <div>
          @for (gr of definition.groups; track gr) {
            <div>
              <h5>{{ t(gr.groupName) }}</h5>
              <div [formGroupName]="gr.groupName">
                @for (input of gr.inputs; track input) {
                  <div>
                    @switch (input.type) {
                      @case ('input') {
                        <anihis-text-input
                          [label]="t(input.formControlName)"
                          [placeholder]="''"
                          [type]="'text'"
                          [formControlName]="input.formControlName"
                        ></anihis-text-input>
                      }
                      @case ('date') {
                        <anihis-date-input
                          [label]="t(input.formControlName)"
                          [formControlName]="input.formControlName"
                        ></anihis-date-input>
                      }
                      @case ('textbox') {
                        <mat-form-field appearance="outline">
                          <mat-label>{{ t(input.formControlName) }}</mat-label>
                          <textarea
                            matInput
                            rows="4"
                            [formControlName]="input.formControlName"
                          ></textarea>
                          @if (input.hint) {
                            <mat-hint>{{ input.hint }}</mat-hint>
                          }
                          <mat-error
                            *ngIf="
                              group
                                .get(gr.groupName)
                                ?.get(input.formControlName)
                                ?.hasError('required') &&
                              (group
                                .get(gr.groupName)
                                ?.get(input.formControlName)?.touched ||
                                group
                                  .get(gr.groupName)
                                  ?.get(input.formControlName)?.dirty)
                            "
                          >
                            {{ t(input.formControlName) }} is required
                          </mat-error>
                        </mat-form-field>
                      }
                      @case ('checkbox') {
                        <mat-checkbox
                          [formControlName]="input.formControlName"
                          >{{ t(input.formControlName) }}</mat-checkbox
                        >
                      }
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (definition.inputs && !definition.groups) {
        <div>
          @for (input of definition.inputs; track input) {
            <div>
              @switch (input.type) {
                @case ('input') {
                  <anihis-text-input
                    [label]="t(input.formControlName)"
                    [placeholder]="''"
                    [type]="'text'"
                    [formControlName]="input.formControlName"
                  ></anihis-text-input>
                }
                @case ('date') {
                  <anihis-date-input
                    [label]="t(input.formControlName)"
                    [formControlName]="input.formControlName"
                  ></anihis-date-input>
                }
                @case ('textbox') {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ t(input.formControlName) }}</mat-label>
                    <textarea
                      matInput
                      rows="4"
                      [formControlName]="input.formControlName"
                    ></textarea>
                    @if (input.hint) {
                      <mat-hint>{{ input.hint }}</mat-hint>
                    }
                    <mat-error
                      *ngIf="
                        group
                          .get(input.formControlName)
                          ?.hasError('required') &&
                        (group.get(input.formControlName)?.touched ||
                          group.get(input.formControlName)?.dirty)
                      "
                    >
                      {{ t(input.formControlName) }} is required
                    </mat-error>
                  </mat-form-field>
                }
                @case ('checkbox') {
                  <mat-checkbox [formControlName]="input.formControlName">{{
                    t(input.formControlName)
                  }}</mat-checkbox>
                }
              }
            </div>
          }
        </div>
      }
    </form>
  }
</ng-container>
